/**
 * NER-4488 fase 2 — Helpers puros de las plantillas de promociones.
 */

import { getPromoTemplate, WEEKDAYS, WEEKEND, EVERY_DAY } from '../data/promoTemplates';
import { EMPTY_FORM } from './promoMapper';
import { nameMatchesHints } from './text';

/**
 * Categorías de la carta (shape de `getMenu`) cuyo nombre matchea las pistas
 * de la plantilla. Devuelve sus `categoryId`. Sin pistas → [] (toda la carta).
 */
export function guessCategoryIds(menuData, hints) {
  if (!hints || hints.length === 0) return [];
  return (menuData || [])
    .filter((category) => category.status !== 'deleted' && nameMatchesHints(category.name, hints))
    .map((category) => category.categoryId);
}

/**
 * Convierte una plantilla en el estado plano del formulario de PromotionsPage
 * (ver `EMPTY_FORM` en promoMapper). `t` es la función de i18n.
 */
export function templateToForm(templateOrId, menuData, t) {
  const template = typeof templateOrId === 'string' ? getPromoTemplate(templateOrId) : templateOrId;
  if (!template) return null;
  return {
    ...EMPTY_FORM,
    name: t(`promoTemplates.${template.id}.name`),
    type: template.type,
    days: [...template.days],
    startTime: template.start,
    endTime: template.end,
    discountType: template.discountType,
    discountValue: template.discountValue,
    categoryIds: guessCategoryIds(menuData, template.categoryHints),
    itemIds: [],
    isActive: true,
  };
}

function sameSet(a, b) {
  if (a.length !== b.length) return false;
  const set = new Set(a);
  return b.every((day) => set.has(day));
}

/** "Lun a Vie", "Sáb y Dom", "Todos los días" o la lista de días abreviados. */
export function describeDays(days, t) {
  if (sameSet(days, EVERY_DAY)) return t('templates.chips.everyDay');
  if (sameSet(days, WEEKDAYS)) return t('templates.chips.weekdays');
  if (sameSet(days, WEEKEND)) return t('templates.chips.weekend');
  return days.map((day) => t(`promotions.days.${day}`)).join(', ');
}

/** "18:00 - 20:00" o "Todo el día" cuando cubre las 24 h. */
export function describeHours(start, end, t) {
  if (start === '00:00' && end === '23:59') return t('templates.chips.allDay');
  return `${start} - ${end}`;
}

/** "20%" o "$500". */
export function describeDiscount(discountType, discountValue) {
  return discountType === 'percentage' ? `${discountValue}%` : `$${discountValue}`;
}
